import { Col, Container, Row } from "react-bootstrap";
import { Commitment, Efficiency, Security } from "./images/svg/icons";
import "../scss/business-styling-component/benefits.style.scss";
import { useTranslation } from "react-i18next";

interface FeatureCardProps {
  title: string;
  description: string;
  icon: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ title, description, icon }) => (
  <Col xs={12} sm={6} md={4} lg={4} className="mb-4 benefit-card-col px-0">
    <div className=" d-flex flex-column align-items-start  h-100">
      <div className="feature-card-header d-flex">
        <div className="icon-container">
          <img src={icon} alt="" className="feature-card-icon" />
        </div>
        <h5 className="Heading_h5 mb-0">{title}</h5>
      </div>
      <p className="feature-card-description-benefits pr-0 pr-sm-5 mt-1 pt-3 mb-0">{description}</p>
    </div>
  </Col>
);

export const Benefits = () => {
  const { t } = useTranslation();
  const isMobile = window.innerWidth < 576;
  const isDesktop = window.innerWidth > 1440 // Bootstrap's mobile breakpoint
  return (
    <>
      <Container>
        <div className="benefits-container">
          <div className={`benefits-header d-flex flex-column align-items-sm-center  justify-content-sm-center ${isMobile ? 'pt-5 py-3 mb-0 mt-1': '' } `}>
            <h2 className="Heading_h2 mb-3">{t("BENEFITS")}</h2>
            <h6 className="Heading_h6 mb-0">
              {t("BENEFITS_HEADER_DESC_1")}
              {isDesktop && <br />}
              {t("BENEFITS_HEADER_DESC_2")}
            </h6>
          </div>
          <Row className="padding-90 py-5">
            <FeatureCard
              title={t("COMMITMENT")}
              description={t("COMMITMENT_DESC_BENEFITS")}
              icon={Commitment}
            />
            <FeatureCard
              title={t("EFFICIENCY")}
              description={t("EFFICIENCY_DESC__BENEFITS")}
              icon={Efficiency}
            />
            <FeatureCard
              title={t("SECURITY")}
              description={t("SECURITY_DESC__BENEFITS")}
              icon={Security}
            />
          </Row>
        </div>
      </Container>
    </>
  );
};
